import { Link, useLocation } from "react-router-dom";
import { Star } from "lucide-react";

/**
 * StickyReviewsTab
 *
 * Right-edge vertical pill anchored mid-viewport. Reads "★ Reviews"
 * bottom-to-top (writing-mode: vertical-rl, no rotation). Tap → /reviews.
 *
 * Visibility rules (per owner):
 *   - Hidden on /reviews itself
 *   - Hidden on /checkout, /order/success/*, /pay/* so it never covers
 *     the primary payment CTA on mobile
 *   - Visible everywhere else (desktop + mobile)
 */
const HIDDEN_PATTERNS = [
  /^\/reviews(\/|$)/,
  /^\/checkout(\/|$)/,
  /^\/order\/success(\/|$)/,
  /^\/pay\/[^/]+$/,
];

const StickyReviewsTab = () => {
  const { pathname } = useLocation();
  if (HIDDEN_PATTERNS.some((re) => re.test(pathname))) return null;

  return (
    <Link
      to="/reviews"
      data-testid="sticky-reviews-tab"
      aria-label="Read customer reviews"
      className="
        fixed right-0 top-1/2 z-40 -translate-y-1/2
        flex items-center justify-center
        py-3 px-1.5
        bg-neutral-900 text-white
        rounded-l-lg shadow-lg
        hover:bg-neutral-800 active:bg-black
        transition-colors
        select-none
      "
    >
      <span
        className="
          flex items-center gap-1.5
          text-[11px] font-medium
          tracking-[0.12em]
          [writing-mode:vertical-rl] [transform:rotate(180deg)]
        "
      >
        <Star className="w-2.5 h-2.5 fill-current shrink-0" aria-hidden />
        Reviews
      </span>
    </Link>
  );
};

export default StickyReviewsTab;
